import React from "react";
import { URLImgFront } from '../../../../config/URLDB';
import ReCAPTCHA from "react-google-recaptcha";
import Loading from '../../../Loading';
import Swal from 'sweetalert2';
import { ConsultarRepresentanteCampania, ListTiposIdentificacion_ } from '../../../../services/WebAPI_Utrahuilca';

class FormRepresentanteLegal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            tipoiden: 'DEFAULT',
            nit: '',
            fecexpe: '',
            errors: {},
            estadoLoading: false,
            tiposid: [],

            //VARIABLE PARA EL CAPTCHA
            consulta: true,
            estado: true,
        };

        this.recaptchaRef = React.createRef();
    }

    async componentDidMount() {
        await this.CargarTipoIdentificacion();
    }

    CargarTipoIdentificacion = async () => {
        const datos = { tran: 7, idtipodoc: 0, abreviatura: 'N/A', desctipodoc: 'N/A', abrevutraweb: 'N/A', idtipopers: 0, estado: 1 };
        try {
            const registros = await ListTiposIdentificacion_(datos);
            const cantregistros = registros?.length ?? 0;
            const sinresultados = registros[0]?.message === '004404';
            if (cantregistros > 0 && !sinresultados) {
                let tiposid = [];
                for (const tipoid of registros) {
                    tiposid.push({ value: tipoid.idtipodoc, label: tipoid.desctipodoc, abrevutraweb: tipoid.abrevutraweb });
                }
                this.setState({
                    tiposid
                });
            }
        }
        catch {
            this.MostrarModal('Ocurrio un error!');
        }
    }

    validarCampos = (valores) => {
        const errors = {}
        if (valores.tipoiden === 'DEFAULT') {
            errors.tipoiden = 'campo obligatorio'
        }
        if (!valores.nit) {
            errors.nit = 'campo obligatorio'
        }
        if (!valores.fecexpe) {
            errors.fecexpe = 'campo obligatorio'
        }
        return errors;
    };

    asignarValor = (e) => {
        let { name, value } = e.target;

        //NO PERMITE SÍMBOLOS 
        if (name === 'nit') {
            if (this.state.tipoiden === 'PAS') {
                value = value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
            } else { //NI LETRAS
                value = value.replace(/[^0-9]/g, '');
            }
        }

        if (name === "fecexpe") {
            //SE TOMA EXACTAMENTE EL AÑO
            const yearPart = value.split("-")[0];
            if (yearPart.length > 4) {
                this.setState({ [yearPart]: "" }); return;
            }
        }

        this.setState({ [name]: value });
    };

    ConsultarDatos = () => {
        const { errors, ...sinErrors } = this.state;
        const resultado = this.validarCampos(sinErrors);
        this.setState({ errors: resultado });

        //SE VALIDA SI HAY CAMPOS INCOMPLETOS
        if (Object.keys(resultado).length > 0) {
            if (this.recaptchaRef.current) {
                this.recaptchaRef.current.reset();
            }
            return;
        }

        if (!Object.keys(resultado).length) {
            this.setState({
                estadoLoading: true
            });

            const data = {
                tran: 4,
                tipoiden: this.props.tipoiden,
                nit: this.props.nit,
                tipoidenrela: this.state.tipoiden,
                nitrela: this.state.nit,
                fecexpe: this.state.fecexpe,
                idcampania: 36
            }

            ConsultarRepresentanteCampania(data).then(response => {
                try {
                    if (response.data.length > 0) {
                        if (response.data[0].codresp) {

                            if (this.recaptchaRef.current) {
                                this.recaptchaRef.current.reset();
                            }

                            Swal.fire({
                                icon: 'error',
                                title: response.data[0].desresp
                            })
                        }
                        else {
                            this.props.mostrarPuntos(true);
                            this.props.mostrarConsulta(true, 2)
                            this.props.asignarDatosBasicos(null, null, null, null, response.data[0].nitrela, response.data[0].correo, response.data[0].telmovi, response.data[0].tipoidenrela);
                        }
                    }
                }
                catch (error) {
                    this.setState({
                        tipoiden: 'DEFAULT',
                        nit: '',
                        fecexpe: '',
                        errors: {},
                        nombre: '',
                        puntos: 0,
                        estado: false
                    });

                    if (this.recaptchaRef.current) {
                        this.recaptchaRef.current.reset();
                    }

                    Swal.fire({
                        icon: 'error',
                        title: 'Novedad en la consulta de puntos'
                    })
                }

                this.setState({
                    estadoLoading: false
                });
            });
        }
    }

    render() {
        const { tipoiden, nit, fecexpe, errors } = this.state;
        return (
            <div className="aos-button-wrapper d-flex justify-content-center" data-aos="fade-right" >
                <div className="d-flex justify-content-center flex-column align-items-center" style={{ gap: "20px" }}>
                    <p style={{ fontSize: 'clamp(30px, 4vw, 60px)', color: '#ff6a00' }}>Representante Legal</p>
                    <div className="text-center">
                        <h5 className="font-weight-bold mb-1" style={{ color: '#ff6a00' }}>Tipo de documento</h5>
                        <select name="tipoiden" className="coopenautas-control-consulta" value={tipoiden} onChange={this.asignarValor}>
                            <option value="DEFAULT" disabled>Selecciona...</option>
                            {this.state.tiposid.map((e, i) => {
                                return [
                                    <option key={i} value={e.abrevutraweb}>{e.label}</option>
                                ]
                            })}
                        </select>
                        {errors.tipoiden && <strong className="text-danger small">{errors.tipoiden}</strong>}
                    </div>
                    <div className="text-center">
                        <h5 className="font-weight-bold mb-1" style={{ color: '#ff6a00' }}>Número de documento</h5>
                        <input name="nit" type="text" className="coopenautas-control-consulta" value={nit} maxLength="20" onChange={this.asignarValor} />
                        {errors.nit && <strong className="text-danger small">{errors.nit}</strong>}
                    </div>
                    <div className="text-center">
                        <h5 className="font-weight-bold mb-1" style={{ color: '#ff6a00' }}>Fecha expedición</h5>
                        <input name="fecexpe" type="date" className="coopenautas-control-consulta" value={fecexpe} onChange={this.asignarValor} />
                        {errors.fecexpe && <strong className="text-danger small">{errors.fecexpe}</strong>}
                    </div>
                    <div className="d-flex justify-content-center">
                        <ReCAPTCHA ref={this.recaptchaRef} sitekey="6LfTTPgbAAAAAOKQp-b36jm-sJGpLIKw8cnZTzu-" onChange={() => this.setState({ consulta: !this.recaptchaRef.current.getValue() })} />
                    </div>
                    <div className="d-flex" style={{ gap: "10px" }}>
                        <button id="BtnRegresar" className="coopenautas-btn" style={{ backgroundImage: `url(${URLImgFront}/assets/EstrategiasComerciales/Coopenautas/BtnRegresar.svg)`, width: 'clamp(100px, 40vw, 200px)', aspectRatio: '200/ 50' }} onClick={() => this.props.mostrarConsulta(false, 1)} />
                        <button id="BtnConsultar" className="coopenautas-btn" style={{ backgroundImage: `url(${URLImgFront}/assets/EstrategiasComerciales/Coopenautas/BtnConsultar.svg)`, width: 'clamp(100px, 40vw, 200px)', aspectRatio: '200/ 50' }} disabled={this.state.consulta} onClick={this.ConsultarDatos} />
                    </div>
                    
                    {this.state.estadoLoading && (
                        <div style={{ maxWidth: '1000px', maxHeight: '580px', height: '580px', width: '1000px', overflow: 'hidden', zIndex: 99999999, position: 'absolute' }}>
                            <div style={{ transform: 'scale(0.8)', transformOrigin: 'top left', width: '125%', height: '125%' }}>
                                <Loading alto={'100%'} />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default FormRepresentanteLegal;